import { render, staticRenderFns } from "./ajuda.vue?vue&type=template&id=7a36dedb&scoped=true"
import script from "./ajuda.vue?vue&type=script&lang=ts"
export * from "./ajuda.vue?vue&type=script&lang=ts"
import style0 from "./ajuda.vue?vue&type=style&index=0&id=7a36dedb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a36dedb",
  null
  
)

export default component.exports